import React from 'react';
import shape4 from "../../../assets/images/resource/choose-05.png";
import shape5 from "../../../assets/images/shapes/shape-11.png";
import shape6 from "../../../assets/images/shapes/shape-12.png";
import shape7 from "../../../assets/images/resource/choose-03.png";


const Choose = () => {
    return (
        <section className="choose___two see__pad p_relative">
        <div className="pattern-layer">
            <div className=" pattern-1 p_absolute" data-parallax='{"x": -75}' style={{ backgroundImage: `url(${shape7})` }}></div>
        </div>
        <div className="auto-container">
            <div className="row">
                <div className="col-lg-5 col-md-16">
                    <div className="choose_img__block">
                        <div className="title__data">
                            <div className="sub__title">
                                <h4 style={{color: "#000"}}><br/>Partner with us</h4>
                            </div>
                            {/* <div className="title">
                                <h2>Our Approach</h2>
                            </div> */}
                        </div>
                        <div className="choose_img__two p_relative">
                            {/* <div className="pattern-layer">
                                <div className=" pattern-3 p_absolute" data-parallax='{"y": 10}' style={{ backgroundImage: `url(${shape5})` }}></div>
                            </div>
                            <div className="pattern-layer">
                                <div className=" pattern-4 p_absolute" data-parallax='{"y": -10}' style={{ backgroundImage: `url(${shape6})` }}></div>
                            </div> */}
                            <figure className="wow zoomIn animated animated" data-wow-delay="100ms" data-wow-duration="1500ms">
                                <img src={shape4} alt="" />
                            </figure>
                        </div>
                    </div>
                </div>
                <div className="col-lg-5 col-md-16">
                    <div className="choose__text__block">
                        <h2>Get Cutting Edge Solutions for your Complex Problems</h2>
                        <div className="normal__text">
                            <p><b>Proven Expertise</b> - As a federal prime contractor, we bring deep technical expertise in engineering, full stack software development, Artificial Intelligence, and wearable technology to solve complex challenges.</p>
                        </div>
                        <div className="normal__text">
                            <p><b>Trusted Partnerships</b> - We collaborate with agencies across the Department of Defense, leading universities, and industry innovators to drive cutting-edge solutions.</p>
                        </div>
                        <div className="normal__text">
                            <p><b>Government & Commercial Impact</b> - Our solutions power mission-critical research across defense, healthcare, and engineering sectors for both government and industry.</p>
                        </div>
                        <div className="normal__text">
                            <p><b>Research-Driven Approach</b> - We leverage advanced R&D and strategic problem-solving to develop high-impact, scalable technologies.</p>
                        </div>
                        {/* <div className="customaize__solution">
                            <div className="customaize__block">
                                <h5>Customized Solutions:</h5>
                                <p>We understand that every business has unique needs. </p>
                            </div>
                            <div className="customaize__block">
                                <h5>Customized Solutions:</h5>
                                <p>We understand that every business has unique needs. </p>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    </section>
    );
};

export default Choose;